import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { ChallanService } from 'src/app/services/challan-services.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Component({
  selector: 'app-sanction-letter',
  templateUrl: './sanction-letter.component.html',
  styleUrls: ['./sanction-letter.component.scss']
})
export class SanctionLetterComponent implements OnInit {
  @Input() appId: any;
  @Input() progId: any;

  public sanctionLetterData: any;
  // public appId: any;
  // public progID: any;
  public sanctionLetterDataForTable: any[];

  public isPrintClicked: boolean = false;
  
  constructor(
    private challanMIService: ChallanService,
    private messageService: MessageService,
    private route : ActivatedRoute,
    private activityRecordService : ActivityRecordService,
    private loader: AppLoaderService,
    private cryptoJsService: CryptoJsService, 
  ) { }

  ngOnInit(): void {
    // this.appId = this.route.snapshot.params.id;
    // this.progId = this.route.snapshot.params.programId;
    this.getSanctionLetterData(this.appId, this.progId);
  }

  getSanctionLetterData(appId, progId) {
    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerConfData = new Map(encData);
    let mobile = farmerConfData.get('farmerPh') ? farmerConfData.get('farmerPh') : '';
    this.loader.start();
    this.challanMIService
      .getSanctionLetterData(appId, progId)
      .pipe(first())
      .subscribe({
        next: (res) => {
          // this.activityRecordService.activityRecord(mobile, 'Sanction Letter', appId, new Date(), 'Success');

          this.sanctionLetterDataForTable = [res];
          this.sanctionLetterData = res;
          this.loader.close();
        },
        error: (err) => {
          // this.activityRecordService.activityRecord(mobile, 'Sanction Letter', appId, new Date(), err);
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  
  onPrint(divName){
    this.isPrintClicked = true;
    // var printContents = document.getElementById(divName).innerHTML;
    // var originalContents = document.body.innerHTML;        
    // document.body.innerHTML = printContents;
    // window.print();
    // document.body.innerHTML = originalContents;
    document.body.style.visibility="hidden";
    document.getElementById(divName).style.visibility='visible'
    window.print();
    document.body.style.visibility="visible";
  }
}
